import React from 'react';
import { LayoutGrid, List, RefreshCw, Rocket } from 'lucide-react';

import { Button } from '@/Modules/Core/Components/shadcn/button';
import { cn } from '@/lib/utils';

const VIEW_OPTIONS = [
  {
    value: 'grid',
    label: 'Grid',
    icon: LayoutGrid,
  },
  {
    value: 'table',
    label: 'Table',
    icon: List,
  },
];

const ProjectsCatalogHeader = ({
  viewMode,
  onViewModeChange,
  onRefresh,
  onCreateRollout,
  canCreateRollout = true,
}) => (
  <div className="flex flex-col gap-5 border-b border-border/40 pb-5 lg:flex-row lg:items-center lg:justify-end">
    <div className="flex flex-wrap items-center gap-2">
      <div className="inline-flex items-center gap-1 rounded-xl bg-muted/25 p-1">
        {VIEW_OPTIONS.map((option) => {
          const Icon = option.icon;

          return (
            <Button
              key={option.value}
              type="button"
              size="icon-sm"
              variant="ghost"
              className={cn(
                'rounded-xl',
                viewMode === option.value
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground'
              )}
              aria-label={`${option.label} view`}
              aria-pressed={viewMode === option.value}
              title={`${option.label} view`}
              onClick={() => onViewModeChange(option.value)}
            >
              <Icon className="h-4 w-4" />
            </Button>
          );
        })}
      </div>

      <Button
        type="button"
        size="icon"
        variant="outline"
        aria-label="Refresh projects"
        title="Refresh projects"
        onClick={onRefresh}
      >
        <RefreshCw className="h-4 w-4" />
      </Button>

      {canCreateRollout ? (
        <Button
          type="button"
          className="h-9 rounded-xl bg-primary px-4 text-[13px] text-primary-foreground hover:bg-primary/90"
          onClick={onCreateRollout}
        >
          <Rocket className="mr-2 h-4 w-4" />
          Create Rollout
        </Button>
      ) : null}
    </div>
  </div>
);

export default ProjectsCatalogHeader;
